((document, Drupal) => {
  "use strict";
  Drupal.behaviors.tabGroup = {
    attach: (context) => {
      if (context === document) {
        if (!document.querySelector('.tab-group')) return;
        
        const tabGroups = context.querySelectorAll(".tab-group");
        tabGroups.forEach(group => {
          
          const tabButtons = group.querySelectorAll(".tabs-title");

          tabButtons.forEach(button => {
            button.addEventListener("click", e => {

              const activeTitle = group.querySelector(".tabs-title.active");
              activeTitle.classList.remove("active");
              const activePanel = group.querySelector(".tabs-panel.active");
              activePanel.classList.remove("active");

              const tabPanelId = button.getAttribute("tab");
              const panel = context.getElementById(tabPanelId);
              button.classList.add("active");
              panel.classList.add("active");
            });
          });

        });
      }
    }
  }
})(document, Drupal);